import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// CMS PAY VERIFICATION RELATED APIs
// ==============================================

// 1. Get Verify CMS Pay Inbox (GET)
export const getVerifyCMSPay = async (params) => {
    try {
        const { roleId } = params;
         // DEBUG
        
        // Validate required parameters
        if (!roleId) {
            throw new Error('RoleID is required');
        }
        
        const queryParams = new URLSearchParams({
            Roleid: roleId.toString().trim()
        });
        
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetVerifyCMSPay?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get CMS Data by Transaction Number (POST)
export const getCMSDataByTransNo = async (params) => {
    try {
         // DEBUG
        
        // Validate required parameters
        if (!params.cmsTransactionNo) {
            throw new Error('CMSTransactionNo is required');
        }
        
        const payload = {
            CMSTransactionNo: params.cmsTransactionNo.toString().trim(),
            ConsolidateNo: params.consolidateNo?.toString().trim() || '',
            TransactionRefno: params.transactionRefno?.toString().trim() || '',
            Month: params.month ? parseInt(params.month) : 0,
            Year: params.year ? parseInt(params.year) : 0
        };
        
         // DEBUG
         // DEBUG
        
        const response = await axios.post(
            `${API_BASE_URL}/HR/GetCMSDatatbyTransNo`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Approve CMS Pay (PUT)
export const approveCMSPay = async (params) => {
    try {
         // DEBUG
        
        // Validate required parameters
        if (!params.cmsTransactionNo) {
            throw new Error('CMSTransactionNo is required');
        }
        if (!params.roleId) {
            throw new Error('RoleId is required');
        }
        if (!params.action) {
            throw new Error('Action is required');
        }
        if (!params.createdBy) {
            throw new Error('CreatedBy is required');
        }
        
        const payload = {
            CMSTransactionNo: params.cmsTransactionNo.toString().trim(),
            TransactionRefno: params.transactionRefno?.toString().trim() || '',
            ConsolidateNo: params.consolidateNo?.toString().trim() || '',
            Roleid: parseInt(params.roleId),
            Action: params.action.toString().trim(),
            Note: params.note?.toString().trim() || '',
            CreatedBy: params.createdBy.toString().trim()
        };
        
         // DEBUG
         // DEBUG
        
        const response = await axios.put(
            `${API_BASE_URL}/HR/ApproveCMSPay`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};